import { Component, ElementRef, ViewChild } from '@angular/core';
import { CommondataService } from '../source/services/games/commondata.service';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SlotsService } from '../source/services/slotsservice/slots.service';
import { GamesService } from '../source/services/games/games.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-footer-provider',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterModule],
  templateUrl: './footer-provider.component.html',
  styleUrl: './footer-provider.component.css'
})
export class FooterProviderComponent {
  @ViewChild('widgetsprovider', { read: ElementRef, static: false }) widgetsprovider!: ElementRef;
  providerLeftArrowDisabledVal = true;
  providerRightArrowDisabledVal = false;
  ProviderImages: any[] = [
    { "image": "../../../assets/siteImg/Providers/Originals.svg", "provider": "ballagames", "Links": "ballagames" },
    { "image": "../../../assets/siteImg/Providers/Evolution.svg", "provider": "Evolution", "Links": "livecasino" },
    { "image": "../../../assets/siteImg/Providers/Ezugi.svg", "provider": "Ezugi", "Links": "livecasino" },
    { "image": "../../../assets/siteImg/Providers/Pragmaticplay.svg", "provider": "PragmaticPlay", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/PragmaticPlayLive.svg", "provider": "Pragmaticplaylivecasino", "Links": "livecasino" },
    { "image": "../../../assets/siteImg/Providers/5men.svg", "provider": "fivemen", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Arrows edge.svg", "provider": "arrowsedge", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Highroller.svg", "provider": "HRG", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Hebanaro.svg", "provider": "habanero", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Injoy.svg", "provider": "injoy", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/JDB.svg", "provider": "JDB", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Netent.svg", "provider": "netent", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Platipus.svg", "provider": "platipus", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Red tiger.svg", "provider": "redtiger", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Rocketman.svg", "provider": "", "Links": "aviator" },
    { "image": "../../../assets/siteImg/Providers/Spribe.svg", "provider": "spribe", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Amb.svg", "provider": "AMB", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Yellow bat.svg", "provider": "YB", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Tomhorn.svg", "provider": "Tomhorn", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Nucleus.svg", "provider": "Nucleus", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Gtf.svg", "provider": "GTF", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Jili.svg", "provider": "Jilits", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Betsoft.svg", "provider": "betsoftts", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Rubyplay.svg", "provider": "rubyplayts", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Kagaming.svg", "provider": "Kagaming", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Simpleplay.svg", "provider": "simpleplayts", "Links": "slots" },
    { "image": "../../../assets/siteImg/Providers/Aviatrix.svg", "provider": "Aviatrix", "Links": "slots" },

  ];

  providerJSON: any;
  filteredImages: any[] = [];
  constructor(private router: Router, private comman: CommondataService, private slotsservice: SlotsService, private gameService:GamesService) {
    this.gameService.providerList$.subscribe((data: any) => {
      this.providerJSON = data;

      if (this.providerJSON && this.ProviderImages) { 
        let allowedProviders = Array.from(new Set( this.providerJSON));
        this.filteredImages = this.ProviderImages.filter(img => {
          const provider = img.provider?.toLowerCase() || "";
          return allowedProviders.includes(provider);
        });
        console.log(allowedProviders)
        console.log(this.filteredImages)
      } else {
        this.filteredImages = []; // fallback if data isn't ready
      }
    });


  }
  providerscrollRight() {
    const el = this.widgetsprovider.nativeElement;
    el.scrollTo({ left: el.scrollLeft + window.innerWidth, behavior: 'smooth' });

    setTimeout(() => this.ProviderScrollButtons(), 300);
  }

  providerscrollLeft() {
    const el = this.widgetsprovider.nativeElement;
    el.scrollTo({ left: el.scrollLeft - window.innerWidth, behavior: 'smooth' });

    setTimeout(() => this.ProviderScrollButtons(), 300);
  }
  ProviderScrollButtons() {
    const elProvider = this.widgetsprovider?.nativeElement;
    if (elProvider) {
      this.providerLeftArrowDisabledVal = elProvider.scrollLeft <= 0;
      this.providerRightArrowDisabledVal = elProvider.scrollLeft + elProvider.offsetWidth >= elProvider.scrollWidth;
    }
  }
  routerLinksprovider(data: any) {
    console.log(data)
    if (data) {
      localStorage.setItem('provider', data)
      this.comman.setValue(data);
      if(data == 'evolution'|| data == 'ezugi'|| data == 'evolutiongv'|| data == 'ezugigv' || data == 'pragmaticplaylivecasino' || data == 'vivogaming'){
        this.router.navigate(['/livecasino'])
      }else if(data == 'ballagames'){
        this.router.navigate(['/ballagames'])
      }else{
        this.router.navigate(['/slots'])
      }
    } else {
      this.router.navigate(['/home'])
    }
    setTimeout(()=>{
      localStorage.removeItem('provider')
    },3000)
  }
}
